import React from 'react';
import { Users } from 'lucide-react';

export const TeamIntroSection = () => {
  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Users className="w-8 h-8 text-blue-900" />
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
              Our Team
            </h2>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12 border-l-4 border-blue-900">
          <p className="text-lg text-slate-700 leading-relaxed">
            Our project management team provides extensive experience across the delivery of large-scale data centres, civil infrastructure, utilities, disaster recovery, commercial, healthcare, and government projects. The team includes qualified construction managers, civil engineers and senior civil construction supervisors. With expertise in client-side project management, principal contractor delivery, and DRFA assessment and coordination, this diverse capability enables the team to successfully manage projects through all stages of planning, delivery, compliance, and project completion across both public and private sector environments.
          </p>
        </div>
      </div>
    </section>
  );
};
